import { Dashboard as Constants } from "../constants";
import { dashboardApi as api } from "../../api";

export const dashboardAction = {
  get,
};

function get() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._get().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.DASHBOARD_SUCCESS, payload };
  }
  function failure(error) {
    return { type: Constants.DASHBOARD_FAILED, error };
  }
}
